// extracted by mini-css-extract-plugin
module.exports = {"container":"FormSection_container__1uekp","text":"FormSection_text__FxuiR","separator":"FormSection_separator__1R90Q","fields":"FormSection_fields__3fFRv"};